import styled, { css } from 'styled-components';
import { appTheme } from '../../styles/theme';

export const authFieldInvalidStyles = ($invalid?: boolean) =>
  $invalid
    ? css`
        border-color: ${appTheme.dangerBorder};
        background: ${appTheme.dangerBg};

        &:focus-within {
          border-color: ${appTheme.dangerText};
          box-shadow: 0 0 0 3px rgba(179, 55, 43, 0.12);
        }
      `
    : css`
        &:focus-within {
          border-color: ${appTheme.green};
          box-shadow: 0 0 0 3px rgba(19, 78, 68, 0.1);
        }
      `;

export const AuthField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const AuthFieldLabel = styled.label`
  font-size: 0.8125rem;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: ${appTheme.text};
`;

export const AuthInputShell = styled.div<{ $invalid?: boolean }>`
  display: flex;
  align-items: center;
  min-height: 48px;
  border-radius: ${appTheme.radiusMd};
  border: 1px solid ${appTheme.border};
  background: ${appTheme.surface};
  box-shadow: inset 0 1px 2px rgba(10, 46, 40, 0.04);
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    background 0.2s ease;

  ${({ $invalid }) => authFieldInvalidStyles($invalid)}

  &:hover:not(:focus-within) {
    border-color: ${({ $invalid }) => ($invalid ? appTheme.dangerBorder : '#CFD9D5')};
  }
`;

export const authInputStyles = css`
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: transparent;
  font-family: inherit;
  font-size: 0.9375rem;
  line-height: 1.4;
  color: ${appTheme.text};
  outline: none;

  &::placeholder {
    color: ${appTheme.textMuted};
    opacity: 0.65;
  }
`;

export const AuthTextInput = styled.input<{ $invalid?: boolean }>`
  ${authInputStyles}
`;

export const AuthFieldError = styled.span`
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.45;
  color: ${appTheme.dangerText};
`;

/** OTP / MFA code — centered, tabular digits. */
export const AuthCodeInput = styled.input<{ $invalid?: boolean }>`
  ${authInputStyles}
  text-align: center;
  font-size: 1.375rem;
  font-weight: 600;
  letter-spacing: 0.32em;
  font-variant-numeric: tabular-nums;
  padding: 14px 16px;
`;

export const AuthInputIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 44px;
  color: ${appTheme.textMuted};
  font-size: 0.9375rem;
  line-height: 1;
  user-select: none;
  pointer-events: none;
`;
